import { FormGroup } from '@angular/forms';
import * as moment from 'moment-timezone';

// custom validator to check that two fields match
export function isAfterDate(controlName: string, options?) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const now = moment();

        if (!options) {
            options = {};
        }

        if (!options.pattern) {
            options.pattern = 'DDMMYYYY';
        }

        if (!options.date) {
            options.date = now;
        }

        if (control.errors && !control.errors.isInvalidDate) {
            return;
        }

        if (control.value && moment(control.value, options.pattern).isBefore(options.date)) {
            control.setErrors({
                isInvalidAfterDate: true
            });
        } else {
            control.setErrors(null);
        }
    }
}
